export const EMAIL_INPUT_TYPE = 'email';
export const EMAIL_LABEL = $localize`Email`;
export const BUTTON_TWO = $localize`Login`;
export const BTN_MAT_FLAT = 'mat-flat-button';
export const BTN_STYLE_FILLED_LARGE = 'btn-filled-large';
export const BTN_STYLE_FILLED_LARGE_DISABLED = 'btn-filled-large-disabled';
export const MAIL_ICON = 'mail_outline';
export const TEXT_INPUT_TYPE = 'text';
export const PASSWORD_INPUT_TYPE = 'password';
export const PASSWORD_LABEL = $localize`Password`;
export const PASSWORD_VISIBILITY = false;
export const VISIBILITY_OFF_ICON = 'visibility_off';
export const VISIBILITY_ICON = 'visibility';
export const LOCK_ICON = 'lock_outline';
export const PSW_PLACEHOLDER = $localize`Your Password`;
export const EMAIL_PLACEHOLDER = $localize`Your email`;
export const BTN_MAT_RAISED = 'mat-raised-button';

// Two-factor (2FA) OTP step
export const OTP_CONFIG = { length: 6 };
